<template>
<!--  <component-->
<!--    :is="(eventTransactions.findIndex((evtTrx) => evtTrx.id === transaction.id) === -1-->
<!--      || eventTransactions[this.eventTransactions.length - 1].id === transaction.id)-->
<!--      ? 'transition' : 'div'"-->
  <component
    :is="enableTransition ? 'transition' : ''"
    @before-appear="beforeAnimationEnter"
    @appear="animationEnter"
    @before-leave="beforeAnimationLeave"
    @leave="animationLeave"
    :css="false"
  >
    <div
      :data-transaction-id="transaction.id"
      v-if="isVisible"
      ref="transactionContainer" class="transaction-container"
    >
      <b-modal
          centered
          id="transactionDetails"
          ref="transactionDetails"
          hide-header
          hide-footer
          content-class="modal_content"
          dialog-class="transactionDetails_modal"
        >
        <div class="transactionDetails">
          <div class="transactionDetails_header">
            <img :src="`//${transaction.image_url.replace('{size}', '110x110')}`"
                 class="transactionDetails_picture" v-if="transaction.image_url" alt="">
            <div class="transactionDetails_header_info">
              <div class="transactionDetails_header_date">
                {{ $moment(`${transaction.cr_date}Z`).format('L, LT') }}
              </div>
              <div class="transactionDetails_label">{{ $t('CP.purpose') }}</div>
              <h3 class="transactionDetails_text">{{ transaction.details }}</h3>
            </div>
          </div>
          <div class="transactionDetails_type">
            <div class="transactionDetails_label">{{ $t('CP.transactionType') }}</div>
            <p class="transactionDetails_text">{{ transaction.operation_type }}</p>
          </div>
          <div class="transactionDetails_payer">
            <div class="transactionDetails_label">{{ $t('CP.whoPaid') }}</div>
            <p class="transactionDetails_text">
              <router-link :to="{ name: 'PeoplePage', params: { uid: transaction.payee } }">
                {{
                  transaction.payee === user.user ?
                  $t('CP.me') : $getUserName(getContact(transaction.payee))
                }}
              </router-link>
            </p>
          </div>
          <ul class="transactionDetails_participants">
            <li v-for="participant in transactionParticipants" :key="participant.uid"
                class="transactionDetails_participants_item">
              <router-link :to="`/people/${participant.uid}`">
                <profile-image
                  :src="participant.avatar_url"
                  :user="participant"
                />
              </router-link>
              <p class="transactionDetails_text">
                <router-link :to="{ name: 'PeoplePage', params: { uid: participant.uid } }">
                  {{
                    participant.uid === user.user ?
                    $t('CP.me') : $getUserName(participant)
                  }}
                </router-link>
              </p>
              <span class="transactionDetails_participants_item_amount">
                {{ participant.amount }}
              </span>
            </li>
          </ul>
          <div class="transactionDetails_total">
            {{ $t('CP.total') }}
            <strong>{{ transaction.amount }}</strong>
            <span> {{transaction.currency}}</span>
          </div>
          <div class="transactionDetails_balanceBefore">
            <span class="transactionDetails_balanceTitle">
              {{ $t('CP.balanceBeforeTransaction') }}
            </span>
            <MoneyMessage :moneyAmount="transaction.incoming_balance"
                          :type="getMoneyType(transaction.incoming_balance)"
                          :currency="transaction.currency" />
          </div>
          <div class="transactionDetails_balanceAfter">
            <span class="transactionDetails_balanceTitle">
              {{ $t('CP.balanceAfterTransaction') }}
            </span>
            <MoneyMessage :moneyAmount="transaction.outgoing_balance"
                          :type="getMoneyType(transaction.outgoing_balance)"
                          :currency="transaction.currency" />
          </div>
          <div class="transactionDetails_seenBy" v-if="seenByList.length">
            <div class="transactionDetails_label">{{ $t('CP.peopleSeenList') }}</div>
            <ul>
              <li v-for="person in seenByList" :key="person.uid">
                <router-link :to="`/people/${person.uid}`">
                  <profile-image
                    :src="person.avatar_url"
                    :user="person" width="30px" height="30px"
                  />
                </router-link>
                <span class="transactionDetails_seenBy_name">
                  <router-link :to="{ name: 'PeoplePage', params: { uid: person.uid } }">
                    {{ $getUserName(person) }}
                  </router-link>
                </span>
                <span class="transactionDetails_seenBy_date">
                  {{ $moment(person.seen_ts+'Z').calendar() }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <button-app
          class="form-button"
          @clicked="hideModal"
          color-scheme="gray"
          type="button">
          {{ $t('CP.close') }}
        </button-app>
      </b-modal>
      <article
        ref="transaction"
        :data-is-mobile="isMobile"
        class="transaction"
        :class="{right: transaction.owner_id === user.user
      || (transaction.operation_type === 'comment' && transaction.owner_id === user.user),
      left: (transaction.owner_id !== user.user && transaction.operation_type !== 'comment')
        || (transaction.operation_type === 'comment' && transaction.owner_id !== user.user)
    }"
      >
        <router-link :to="`/people/${getContact(transaction.payee || transaction.owner_id).uid}`">
          <profile-image
            :format="transaction.image_url ? '110x110' : '140x140'"
            :src="transaction.image_url ||
          (getContact(transaction.payee) && getContact(transaction.payee).avatar_url)"
            :user="getContact(transaction.payee || transaction.owner_id)"
            v-if="(transaction.owner_id !== user.user && transaction.operation_type !== 'comment')
          || (transaction.operation_type === 'comment' && transaction.owner_id !== user.user)"
            class="transaction__image"
          />
        </router-link>
        <div
          @click="showTransactionDetails"
          class="transaction__body">
          <div class="transaction__message">
        <span class="transaction__title">
          {{ transaction.details }}
        </span>
            <span
              v-if="transaction.owner_id === user.user"
              class="transaction__delete-button">
          <b-icon
            @click.stop="openConfirmDelete"
            icon="x"
          />
        </span>
          </div>
          <div class="transaction__money">
            <strong>{{ getMoney.amount | formatMoney }} </strong>
            <span class="transaction__money_currency">{{ getMoney.currency }}</span>
          </div>
          <div
            v-if="makeUpStatus.transactionStatus"
            class="transaction__status transaction__transactionStatus"
            v-html="makeUpStatus.transactionStatus"
          >
          </div>
          <div v-if="transaction && transaction.tips" class="transaction__status">
            {{ $t('CP.tips') }}: {{ transaction.tips }} {{ transaction.currency }}
          </div>
          <div v-if="transaction && transaction.service_fee" class="transaction__status">
            {{ $t('CP.serviceFee') }}: {{ transaction.service_fee }}%
          </div>
          <div v-if="makeUpStatus.payeeStatus" class="transaction__status transaction__payeeStatus"
            v-html="makeUpStatus.payeeStatus"
          >
          </div>
          <div
            v-if="typeof userExpenses === 'number' && isFinite(userExpenses)"
            class="transaction__money"
          >
            {{ `${$t('CP.myShare')}: ` }} {{ userExpenses | formatMoney }}
            <span class="transaction__money_currency">{{ getMoney.currency }}</span>
          </div>
          <div class="transaction__actions">
            <a
              v-if="(transaction.operation_type !== 'comment'
            && transaction.operation_type !== 'payback')"
              @click.stop="cloneTransaction"
              class="transaction__copy-transaction">
              {{ $t('CP.clone') }}
            </a>
            <a
              v-if="transaction.owner_id === user.user
            && transaction.operation_type !== 'comment'
            && transaction.operation_type !== 'payback'"
              @click.stop="moveTransaction"
              class="transaction__move-transaction">
              {{ $t('CP.transferOperation') }}
            </a>
          </div>
          <div
            v-if="transaction.owner_id === user.user
          || (transaction.operation_type === 'comment' && transaction.owner_id === user.user)"
            class="message__tail_right"></div>
          <div
            v-if="(transaction.owner_id !== user.user && transaction.operation_type !== 'comment')
          || (transaction.operation_type === 'comment' && transaction.owner_id !== user.user)"
            class="message__tail_left"></div>
        </div>
        <router-link :to="`/people/${user.uid}`">
          <profile-image
            :format="transaction.image_url ? '110x110' : '140x140'"
            :src="transaction.image_url ? transaction.image_url : (user && user.avatar_url)"
            :user="user"
            v-if="transaction.owner_id === user.user
          || (transaction.operation_type === 'comment' && transaction.owner_id === user.user)"
            class="transaction__image"
          />
        </router-link>
        <ul class="transaction__seenBy" v-if="seenByList.length">
          <li v-for="person in seenByList" :key="person.user_id"
              :title="`${$getUserName(person)} (${$moment(person.seen_ts+'Z').format('lll')})`">
            <router-link :to="`/people/${person.uid}`">
                <profile-image
                  :src="person.avatar_url"
                  :user="person" width="30px" height="30px"
                />
            </router-link>
          </li>
        </ul>
        <div
          v-if="showDateTime"
          class="transaction__date"
        >
          {{ getFormattedDate() }}
        </div>
      </article>
      <div  v-if="isTransactionLastSeen && !isLastTransaction"
            ref="transactionNotificationNew" class="transaction_titleNew">
        <span class="transaction_titleNew-text">{{ $t('CP.newOperationsMessage') }}</span>
      </div>
    </div>
  </component>
</template>

<script>
/* eslint-disable no-param-reassign */

import { mapState } from 'vuex';
import {
  SET_CLONE_OPERATION_INFO,
  SET_CONFIRM_MODAL_INFO,
  SET_MOVE_OPERATION_INFO, SET_OPERATION, SET_SPLIT_PURCHASE_INFO,
} from '@/store/operations/types';
import {
  CLEAR_EVENT_EXPENSES_UPDATE_STATUS,
  CLEAR_OPERATIONS_UPDATE_STATUS,
  DELETE_TRANSACTION_REQUEST, EVENT_PAYOUTS_REQUEST, FETCH_EVENT_EXPENSES_REQUEST,
  // FETCH_EVENTS_REQUEST,
  // FETCH_EVENT_REQUEST,
  FETCH_EVENT_SUCCESS,
} from '@/store/events/types';
import {
  SET_EVENT_SELECTED_CONTACTS,
  SET_FINAL_EVENT_SELECTED_CONTACTS,
} from '@/store/user/types';
import MoneyMessage from '../MoneyMessagge/MoneyMessage';
import ProfileImage from '../ProfileImage/ProfileImage';
import ButtonApp from '../Button/ButtonApp';

export default {
  name: 'transaction',
  components: {
    ProfileImage,
    MoneyMessage,
    ButtonApp,
  },
  data() {
    return {
      isVisible: true,
    };
  },
  mounted() {
    const getUpdateLocaleConfig = (locale = this.$i18n.locale) => ({
      calendar: {
        sameDay: this.$t('proposedTransactions.calendarSameDay', locale),
        nextDay: this.$t('proposedTransactions.calendarNextDay', locale),
        nextWeek: 'L, LT',
        lastDay: 'L, LT',
        lastWeek: 'L, LT',
        sameElse: 'L, LT',
      },
    });

    this.$moment.locale(localStorage.getItem('locale') || this.$store.state.app.currentLanguage);
    this.$moment.updateLocale('en', getUpdateLocaleConfig('en'));
    this.$moment.updateLocale('ru', getUpdateLocaleConfig('ru'));
    this.$emit('ready', this.isTransactionLastSeen ? this : null);
    this.isVisible = true;

    if (this.isTransactionLastSeen) {
      this.$nextTick(() => {
        if (this.$refs.transactionNotificationNew) {
          this.scrollObserver.observe(this.$refs.transactionNotificationNew);
        }
      });
    }
    if (!this.isTransactionSeen) {
      this.$nextTick(() => {
        if (this.scrollObserver) {
          this.scrollObserver.observe(this.$el);
        }
      });
    }
  },
  watch: {
    locale() {
      this.$forceUpdate();
    },
    // updateTransactionsStatus() {
    //   this.transactionHeight = (this.$refs.transaction
    //     && this.$refs.transaction.offsetHeight) + 15;
    // },
  },
  computed: {
    ...mapState({
      locale: (state) => state.app.currentLanguage,
      updateTransactionsStatus: (state) => state.events.updateTransactionsStatus,
      updateExpensesStatus: (state) => state.events.eventExpenses.updateStatus,
    }),
    isTransactionLastSeen() {
      return this.lastSeenTransactionId === this.transaction.id;
    },
    isTransactionSeen() {
      return this.transaction.id <= this.lastSeenTransactionId;
    },
    getMoney() {
      if (this.transaction.amount && this.transaction.currency) {
        return {
          amount: this.transaction.amount,
          currency: this.transaction.currency,
        };
      }
      return '';
    },

    makeUpStatus() {
      const isOperationTransfer = this.transaction.operation_type === 'transfer';
      const isOperationPurchase = this.transaction.operation_type === 'purchase';
      const isOperationPayback = this.transaction.operation_type === 'payback';
      const isOperationDeposit = this.transaction.operation_type === 'deposit';
      const isPurchaseEven = this.transaction.purchase_type === 'even';
      const isPurchaseSplit = this.transaction.purchase_type === 'split';
      try {
        if (this.user && this.user.gender
          && this.eventContacts && this.eventContacts.length
          && this.transaction
          && this.transaction.participants && this.transaction.participants.length) {
          let transactionStatus = '';
          let payeeStatus = '';
          const { payee } = this.transaction;
          const { user } = this;
          const transactionParticipants = this.transaction.participants;

          if (isOperationTransfer) {
            transactionStatus = this.getTransferStatus({
              user,
              payee,
              transactionParticipants,
            });
          } else if (isOperationPurchase && isPurchaseEven) {
            ({
              purchaseStatus: transactionStatus,
              payeeStatus = '',
            } = this
              .getEvenPurchaseStatus({
                user,
                payee,
                transactionParticipants,
              }));
          } else if (isOperationPayback) {
            transactionStatus = this.getPaybackStatus({
              user,
              payee,
              transactionParticipants,
            });
          } else if (isOperationDeposit) {
            ({
              depositStatus: transactionStatus,
              payeeStatus = '',
            } = this
              .getDepositStatus({
                user,
                payee,
                transactionParticipants,
              }));
          } else if (isOperationPurchase && isPurchaseSplit) {
            ({
              purchaseStatus: transactionStatus,
              payeeStatus = '',
            } = this
              .getSplitPurchaseStatus({
                user,
                payee,
                transactionParticipants,
              }));
          }
          return {
            transactionStatus,
            payeeStatus,
          };
        }
        return {
          transactionStatus: '',
          payeeStatus: '',
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error in status display:', e.message);
        return '';
      }
    },
    seenByList() {
      return this.transaction.last_seen_for.map((item) => {
        const person = this.eventContacts.find((contact) => contact.uid === item.user_id);
        person.seen_ts = item.seen_ts;
        return person;
      });
    },
    transactionParticipants() {
      return this.transaction.participants.map((participant) => {
        const participantInfo = this.getContact(participant.uid);
        return {
          ...participant,
          ...participantInfo,
        };
      });
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('transactionDetails');
    },
    getMoneyType(amount) {
      if (amount > 0) {
        return 'accrual';
      }
      if (amount < 0) {
        return 'debit';
      }
      return 'neutral';
    },
    showTransactionDetails() {
      if (this.transaction.operation_type !== 'comment') {
        this.$refs.transactionDetails.show();
      }
    },
    beforeAnimationEnter(el) {
      // console.log('beforeAnimationEnter');
      const lastTransaction = this.eventTransactions[this.eventTransactions.length - 1];
      if (this.transaction.id === lastTransaction.id
        && (this.updateTransactionsStatus === 'success' || this.updateExpensesStatus === 'success')) {
        el.style.height = 0;
        el.style.transition = 'height .6s';
      }
    },
    animationEnter(el, done) {
      // console.log('animationEnter');
      const lastTransaction = this.eventTransactions[this.eventTransactions.length - 1];
      if (this.transaction.id === lastTransaction.id
        && (this.updateTransactionsStatus === 'success' || this.updateExpensesStatus === 'success')) {
        setTimeout(() => {
          if (this.$refs.transaction) {
            el.style.height = `${this.$refs.transaction.offsetHeight + 15}px`;
          }
          // console.log(el.computedStyle('height'));
          setTimeout(() => {
            el.style.height = '';
            el.style.transition = '';
          }, 600);
          this.$store.commit(CLEAR_OPERATIONS_UPDATE_STATUS);
          this.$store.commit(CLEAR_EVENT_EXPENSES_UPDATE_STATUS);
        }, 600);
      }
      done();
    },
    beforeAnimationLeave(el) {
      // console.log('beforeAnimationLeave');
      if ((this.updateTransactionsStatus === 'success' || this.updateExpensesStatus === 'success')) {
        el.style.height = `${this.$refs.transaction.offsetHeight + 15}px`;
        el.style.transition = 'height .3s';
      }
    },
    animationLeave(el, done) {
      // console.log('animationLeave');
      if (+this.transaction.event_id !== +this.$route.params.id) {
        done();
        return;
      }
      if ((this.updateTransactionsStatus === 'success' || this.updateExpensesStatus === 'success')) {
        setTimeout(() => {
          el.style.height = 0;
        }, 10);
      }
      setTimeout(() => {
        el.style.height = '';
        el.style.transition = '';
        this.$store.commit(CLEAR_OPERATIONS_UPDATE_STATUS);
        this.$store.commit(CLEAR_EVENT_EXPENSES_UPDATE_STATUS);
        done();
      }, 310);
    },
    cloneTransaction() {
      const { transaction } = this;
      if (transaction.operation_type === 'purchase') {
        if (transaction.purchase_type === 'even') {
          if (transaction.participants.length === 1
            && (transaction.participants[0]
              && transaction.participants[0].uid) === this.user.user) {
            this.$store.commit(SET_OPERATION, 'they purchased me');
          } else {
            this.$store.commit(SET_OPERATION, 'even purchase');
          }
          const clonedContacts = transaction.participants
            .map((participant) => this.getContact(participant.uid));
          this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, clonedContacts);
          this.$store.commit(SET_EVENT_SELECTED_CONTACTS, clonedContacts);
          this.$store.commit(SET_CLONE_OPERATION_INFO, {
            amount: transaction.amount,
            name: transaction.details,
            imageUrl: transaction.image_url,
            payee: this.getContact(transaction.payee).phone,
            currentCurrency: transaction.currency,
          });
        }
        if (transaction.purchase_type === 'split') {
          this.$store.commit(SET_OPERATION, 'split purchase');
          const clonedContacts = transaction.participants
            .map((participant) => this.getContact(participant.uid));
          this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, clonedContacts);
          this.$store.commit(SET_EVENT_SELECTED_CONTACTS, clonedContacts);
          this.$store.commit(SET_SPLIT_PURCHASE_INFO,
            {
              splitUsersMoney: transaction.participants
                .map((participant) => ({
                  phone: this.getContact(participant.uid).phone,
                  money: participant.amount,
                })),
              transactionSum: transaction.amount,
            });
          this.$store.commit(SET_CLONE_OPERATION_INFO, {
            amount: transaction.amount,
            name: transaction.details,
            imageUrl: transaction.image_url,
            payee: this.getContact(transaction.payee).phone,
            currentCurrency: transaction.currency,
          });
        }
      } else if (transaction.operation_type === 'transfer') {
        if (transaction.payee === this.user.user) {
          this.$store.commit(SET_OPERATION, 'i lent them');
        } else {
          this.$store.commit(SET_OPERATION, 'they lent me');
        }
        this.$store.commit(SET_CLONE_OPERATION_INFO, {
          amount: transaction.amount,
          name: transaction.details,
          imageUrl: transaction.image_url,
          payee: this.getContact(transaction.payee).phone,
          recipient: this.getContact(transaction.participants[0].uid).phone,
          currentCurrency: transaction.currency,
        });
      } else if (transaction.operation_type === 'deposit') {
        this.$store.commit(SET_OPERATION, 'deposit');
        const clonedContacts = transaction.participants
          .map((participant) => this.getContact(participant.uid));
        this.$store.commit(SET_FINAL_EVENT_SELECTED_CONTACTS, clonedContacts);
        this.$store.commit(SET_EVENT_SELECTED_CONTACTS, clonedContacts);
        this.$store.commit(SET_CLONE_OPERATION_INFO, {
          amount: transaction.amount,
          name: transaction.details,
          imageUrl: transaction.image_url,
          payee: this.getContact(transaction.payee).phone,
          currentCurrency: transaction.currency,
        });
      } else {
        return;
      }
      this.$bvModal.show('add-transaction');
    },
    moveTransaction() {
      this.$store.commit(SET_MOVE_OPERATION_INFO, {
        current_event_id: this.transaction.event_id,
        transaction_id: this.transaction.id,
        transaction_participants: this.transaction.participants,
      });
      this.$bvModal.show('move-transaction');
    },
    async openConfirmDelete() {
      await this.$store.commit(SET_CONFIRM_MODAL_INFO, {
        question: this.$t('CP.confirmDeleteTransaction'),
        acceptanceTitle: this.$t('CP.yesDelete'),
        denialTitle: this.$t('CP.cancel'),
        submitHandler: this.deleteTransaction.bind(this),
      });
      this.$bvModal.show('app-confirm-modal');
    },
    async deleteTransaction() {
      const transactionData = await this.$store
        .dispatch(DELETE_TRANSACTION_REQUEST, { id: this.transaction.id });
      if (transactionData && transactionData.event_data) {
        this.$store.commit(FETCH_EVENT_SUCCESS, transactionData.event_data);
        this.$store.dispatch(FETCH_EVENT_EXPENSES_REQUEST, {
          ...transactionData.event_data,
          utcOffset: this.$moment()
            .utcOffset(),
          // TODO: find better solution for currency
          // currency: transactionData.currency,
          currency: this.$store.state.events.eventCurrency,
          isUpdate: true,
        });
        this.$store.dispatch(EVENT_PAYOUTS_REQUEST, {
          ...transactionData.event_data,
          // currency: transactionData.currency,
          currency: this.$store.state.events.eventCurrency,
        });
      }
      // this.$store.dispatch(FETCH_EVENTS_REQUEST);
      // this.$store.dispatch(FETCH_EVENT_REQUEST, { id: this.$store.state.events.event.id });
    },
    getFormattedDate() {
      try {
        const crDate = this.$moment(`${this.transaction.cr_date}Z`);
        const now = this.$moment();
        if (now.diff(crDate, 'days') <= 5) {
          return crDate.calendar()
            .replace(/,/g, '');
        }
        return crDate.format('LL');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error in dateFormat:');
        // eslint-disable-next-line no-console
        console.error(e);
        return '';
      }
    },
    addVueLinkToUser(user) {
      return `<a href="/people/${user.uid}" target="_self" style="text-decoration: none;" onclick="event.stopPropagation();event.preventDefault();app.__vue__.$root._router.push('/people/${
        user.uid}');">${this.$getUserName(user)}</a>`;
    },
    getPaybackStatus({ user, payee, transactionParticipants }) {
      try {
        let paybackStatus = '';
        const payeeUser = this.getContact(payee);
        const recipient = this.getContact(transactionParticipants[0].uid);
        if (payeeUser && recipient) {
          if (payee === user.user && transactionParticipants.length) { // user to smb
            paybackStatus += this.$t(`statusMessages.iRepaidThem_${user.gender || 'M'}`,
              { user: this.addVueLinkToUser(this.getContact(transactionParticipants[0].uid)) });
          } else if (payee !== user.user
            && transactionParticipants[0]
            && transactionParticipants[0].uid === user.user) { // smb to user
            paybackStatus += this.$t(`statusMessages.theyRepaidMe_${payeeUser.gender || 'M'}`, { user: this.addVueLinkToUser(payeeUser) });
          } else if (payee !== user.user
            && transactionParticipants[0]
            && transactionParticipants[0].uid !== user.user) { // smb to smb
            paybackStatus += this.$t(`statusMessages.theyRepaidThem_${payeeUser.gender || 'M'}`,
              {
                user1: this.addVueLinkToUser(payeeUser),
                user2: this.addVueLinkToUser(recipient),
              });
          }
          return paybackStatus;
        }
        return '';
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in payback status: ', e.message);
        return '';
      }
    },
    getTransferStatus({ user, payee, transactionParticipants }) {
      try {
        let transferStatus = '';
        const payeeUser = this.getContact(payee);
        const recipient = this.getContact(transactionParticipants[0].uid);
        if (payeeUser && recipient) {
          if (payee === user.user && transactionParticipants.length
            && recipient.uid !== user.user) { // user to smb
            transferStatus += this.$t(`statusMessages.iLentThem_${recipient.gender || 'M'}`, { user: this.addVueLinkToUser(recipient) });
          } else if (payee !== user.user
            && transactionParticipants[0]
            && transactionParticipants[0].uid === user.user) { // smb to user
            transferStatus += this.$t(`statusMessages.theyLentMe_${payeeUser.gender || 'M'}`,
              { user: this.addVueLinkToUser(payeeUser) });
          } else if (payee === user.user && payee === recipient.uid) { // user to user
            transferStatus = this.$t(`statusMessages.iLentMyself_${user.gender || 'M'}`);
          } else if (payee !== user.user && recipient.uid !== user.user
            && payee !== recipient.uid) { // smb to smb
            transferStatus = this.$t(`statusMessages.theyLentThem_${payeeUser.gender || 'M'}`,
              {
                user1: this.addVueLinkToUser(payeeUser),
                user2: this.addVueLinkToUser(recipient),
              });
          } else if (payee !== user.user && payee === recipient.uid) { // smb to himself
            transferStatus = this.$t(`statusMessages.theyLentThemselves_${payeeUser.gender || 'M'}`,
              {
                user: this.addVueLinkToUser(payeeUser),
              });
          }
        }
        return transferStatus;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in transfer status: ', e.message);
        return '';
      }
    },
    getSplitPurchaseStatus({ user, payee, transactionParticipants }) {
      try {
        let purchaseStatus = '';
        let payeeStatus = '';
        const payeeUser = this.getContact(payee);
        const firstParticipant = transactionParticipants[0];
        const userParticipant = transactionParticipants
          .find((participant) => participant.uid === user.user);
        if (payeeUser) {
          // smb for smb
          if (payee !== user.user
            && !userParticipant
            && transactionParticipants.length > 1) {
            purchaseStatus += `${this.$t('statusMessages.splitFor')}: `;
            transactionParticipants.forEach((participant, index) => {
              if (index !== 0) {
                purchaseStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))} (${participant.amount}`
                  + ` ${this.transaction.currency})`;
              } else {
                purchaseStatus += `${this.addVueLinkToUser(this.getContact(participant.uid))} (${participant.amount}`
                  + ` ${this.transaction.currency})`;
              }
            });
            payeeStatus += `${this.$t(`statusMessages.paidBy_${payeeUser.gender || 'M'}`)}: ${this.addVueLinkToUser(payeeUser)}`;
            // smb for himself
          } else if (payee === firstParticipant.uid && payee !== user.user
            && transactionParticipants.length === 1) {
            purchaseStatus += this.$t(`statusMessages.theyBoughtForThemselves_${payeeUser.gender || 'M'}`,
              { user: this.addVueLinkToUser(payeeUser) });
            // user for himself
          } else if (payee === user.user
            && userParticipant
            && transactionParticipants.length === 1) {
            purchaseStatus += this.$t(`statusMessages.iBoughtForMyself_${user.gender || 'M'}`);
            // user for smb
          } else if (payee === user.user && !userParticipant) {
            purchaseStatus += `${this.$t(`statusMessages.iBoughtFor_${user.gender || 'M'}`)}: `;
            transactionParticipants.forEach((participant, index) => {
              if (index !== 0) {
                purchaseStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))} (${participant.amount || ''} ${
                  participant.amount && this.transaction.currency
                })`;
              } else {
                purchaseStatus += `${this.addVueLinkToUser(this.getContact(participant.uid))} (${participant.amount || ''} ${
                  participant.amount && this.transaction.currency
                })`;
              }
            });
            // smb for user
          } else if (payee !== user.user
            && firstParticipant.uid !== user.user
            && transactionParticipants.length === 1) {
            purchaseStatus += `${this.$t(`statusMessages.theyBoughtForMe_${payeeUser.gender || 'M'}`,
              { user: this.addVueLinkToUser(payeeUser) })}`;
            // smb for (smb && user)
          } else if (payee !== user.user
            && userParticipant
            && transactionParticipants.length > 1) {
            purchaseStatus += `${this.$t('statusMessages.splitFor')}: `;
            transactionParticipants.forEach((participant, index) => {
              if (participant.uid !== userParticipant.uid) {
                purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                  ? ', ' : ''}${this.addVueLinkToUser(this.getContact(participant.uid))} (${participant.amount}`
                  + ` ${this.transaction.currency})`;
              } else {
                purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                  ? ', ' : ''}${this.$t('CP.meGenitive')} (${participant.amount} ${this.transaction.currency})`;
              }
            });
            payeeStatus += `${this.$t(`statusMessages.paidBy_${payeeUser.gender || 'M'}`)}: ${this.addVueLinkToUser(payeeUser)}`;
            // user for (smb && user)
          } else if (payee === user.user
            && userParticipant
            && transactionParticipants.length > 1) {
            purchaseStatus += `${this.$t('statusMessages.splitFor')}: `;
            transactionParticipants.forEach((participant, index) => {
              if (participant.uid !== userParticipant.uid) {
                purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                  ? ', ' : ''}${this.addVueLinkToUser(this.getContact(participant.uid))} (${participant.amount}`
                  + ` ${this.transaction.currency})`;
              } else {
                purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                  ? ', ' : ''}${this.$t('CP.meGenitive')} (${participant.amount} ${this.transaction.currency})`;
              }
            });
            payeeStatus += `${this.$t(`statusMessages.paidBy_${payeeUser.gender || 'M'}`)}: ${this.$t('CP.me')}`;
          }
          return {
            purchaseStatus,
            payeeStatus,
          };
        }
        return {
          purchaseStatus: '',
          payeeStatus: '',
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in split purchase status: ', e.message);
        return {
          purchaseStatus: '',
          payeeStatus: '',
          tips: '',
          serviceFee: '',
        };
      }
    },
    getEvenPurchaseStatus({ user, payee, transactionParticipants }) {
      try {
        let purchaseStatus = '';
        let payeeStatus = '';
        const payeeUser = this.getContact(payee);
        const firstParticipant = transactionParticipants[0];
        const userParticipant = transactionParticipants
          .find((participant) => participant.uid === user.user);
        if (payeeUser) {
          // smb for smb
          if (payee !== user.user
            && !userParticipant
            && transactionParticipants.length > 1) {
            purchaseStatus += `${this.$t('statusMessages.evenFor')}: `;
            transactionParticipants.forEach((participant, index) => {
              if (index !== 0) {
                purchaseStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))}`;
              } else {
                purchaseStatus += this.addVueLinkToUser(this.getContact(participant.uid));
              }
            });
            payeeStatus += `${this.$t(`statusMessages.paidBy_${payeeUser.gender || 'M'}`)}: ${this.addVueLinkToUser(payeeUser)}`;
            // smb for himself
          } else if (payee === firstParticipant.uid && payee !== user.user
            && transactionParticipants.length === 1) {
            purchaseStatus += this.$t(`statusMessages.theyBoughtForThemselves_${payeeUser.gender || 'M'}`,
              { user: this.addVueLinkToUser(payeeUser) });
            // user for smb
          } else if (payee === user.user && !userParticipant) {
            purchaseStatus += `${this.$t(`statusMessages.iBoughtFor_${user.gender || 'M'}`)}: `;
            transactionParticipants.forEach((participant, index) => {
              if (index !== 0) {
                purchaseStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))}`;
              } else {
                purchaseStatus += this.addVueLinkToUser(this.getContact(participant.uid));
              }
            });
            // smb for user or smb for smb
          } else if (payee !== user.user
            && transactionParticipants.length === 1) {
            purchaseStatus += `${this.$t(`statusMessages.theyBoughtForSmb_${payeeUser.gender || 'M'}`,
              {
                user1: this.addVueLinkToUser(payeeUser),
                user2: this.addVueLinkToUser(firstParticipant),
              })}`;
            // user for himself
          } else if (payee === user.user
            && userParticipant
            && transactionParticipants.length === 1) {
            purchaseStatus += this.$t(`statusMessages.iBoughtForMyself_${user.gender || 'M'}`);
            // smb for (smb && user)
          } else if (payee !== user.user
            && userParticipant
            && transactionParticipants.length > 1) {
            const transactionAndEventParticipants = transactionParticipants
              .filter((participant) => this.eventContacts
                .findIndex((contact) => participant.uid === contact.uid) !== -1);
            if (transactionAndEventParticipants.length === this.eventContacts.length) {
              purchaseStatus += this.$t('statusMessages.evenForAll');
            } else {
              purchaseStatus += `${this.$t('statusMessages.evenFor')}: `;
              transactionParticipants.forEach((participant, index) => {
                if (participant.uid !== userParticipant.uid) {
                  purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                    ? ', ' : ''}${this.addVueLinkToUser(this.getContact(participant.uid))}`;
                } else {
                  purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                    ? ', ' : ''}${this.$t('CP.meGenitive')}`;
                }
              });
            }
            payeeStatus += `${this.$t(`statusMessages.paidBy_${payeeUser.gender || 'M'}`)}: ${this.addVueLinkToUser(payeeUser)}`;
            // user for (smb && user)
          } else if (payee === user.user
            && userParticipant
            && transactionParticipants.length > 1) {
            const transactionAndEventParticipants = transactionParticipants
              .filter((participant) => this.eventContacts
                .findIndex((contact) => participant.uid === contact.uid) !== -1);
            if (transactionAndEventParticipants.length === this.eventContacts.length) {
              purchaseStatus += this.$t('statusMessages.evenForAll');
            } else {
              purchaseStatus += `${this.$t('statusMessages.evenFor')}: `;
              transactionParticipants.forEach((participant, index) => {
                if (participant.uid !== userParticipant.uid) {
                  purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                    ? ', ' : ''}${this.addVueLinkToUser(this.getContact(participant.uid))}`;
                } else {
                  purchaseStatus += `${(index !== 0) && (transactionParticipants.length !== index - 1)
                    ? ', ' : ''}${this.$t('CP.meGenitive')}`;
                }
              });
            }
            payeeStatus += `${this.$t(`statusMessages.paidBy_${payeeUser.gender || 'M'}`)}: ${this.$t('CP.me')}`;
          }
          return {
            purchaseStatus,
            payeeStatus,
          };
        }
        return {
          purchaseStatus: '',
          payeeStatus: '',
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in even purchase status: ', e.message);
        return {
          purchaseStatus: '',
          payeeStatus: '',
        };
      }
    },
    getDepositStatus({ user, payee, transactionParticipants }) {
      try {
        let depositStatus = '';
        let payeeStatus = '';
        const firstParticipant = transactionParticipants[0];
        const payeeUser = this.getContact(payee);
        // smb for smb
        if (payee !== user.user
          && firstParticipant.uid !== user.user
          && transactionParticipants.length > 1) {
          depositStatus += `${this.$t('statusMessages.incomeFor')}: `;
          transactionParticipants.forEach((participant, index) => {
            if (index !== 0) {
              depositStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))}`;
            } else {
              depositStatus += this.addVueLinkToUser(this.getContact(participant.uid));
            }
          });
          payeeStatus += `${this.$t(`statusMessages.received_${payeeUser.gender || 'M'}`)}: ${this.getContactName(payee)}`;
          // smb for himself
        } else if (payee === firstParticipant.uid && payee !== user.user) {
          depositStatus += this.$t(`statusMessages.theyReceivedForThemselves_${payeeUser.gender || 'M'}`,
            { user: this.addVueLinkToUser(payeeUser) });
          // user for smb
        } else if (payee === user.user && firstParticipant.uid !== user.user) {
          depositStatus += `${this.$t(`statusMessages.iReceivedFor_${payeeUser.gender || 'M'}`)}: `;
          transactionParticipants.forEach((participant, index) => {
            if (index !== 0) {
              depositStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))}`;
            } else {
              depositStatus += this.addVueLinkToUser(this.getContact(participant.uid));
            }
          });
          // smb for user
        } else if (payee !== user.user
          && firstParticipant.uid !== user.user
          && transactionParticipants.length === 1) {
          depositStatus += this.$t(`statusMessages.theyReceivedForMe_${payeeUser.gender || 'M'}`,
            { user: this.addVueLinkToUser(payeeUser) });
          // user for himself
        } else if (payee === user.user
          && firstParticipant.uid === user.user
          && transactionParticipants.length === 1) {
          depositStatus += this.$t(`statusMessages.iReceivedForMyself_${payeeUser.gender || 'M'}`);
          // smb for (smb && user)
        } else if (payee !== user.user
          && firstParticipant.uid === user.user
          && transactionParticipants.length > 1) {
          const transactionAndEventParticipants = transactionParticipants
            .filter((participant) => this.eventContacts
              .findIndex((contact) => participant.uid === contact.uid) !== -1);
          if (transactionAndEventParticipants.length === this.eventContacts.length) {
            depositStatus += this.$t('statusMessages.incomeForAll');
          } else {
            depositStatus += `${this.$t('statusMessages.incomeFor')}: `;
            transactionParticipants.forEach((participant, index) => {
              if (index !== 0) {
                depositStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))}`;
              } else {
                depositStatus += this.$t('CP.meGenitive');
              }
            });
          }
          payeeStatus += `${this.$t(`statusMessages.received_${payeeUser.gender || 'M'}`)}: ${this.getContactName(payee)}`;
          // user for (smb && user)
        } else if (payee === user.user
          && firstParticipant.uid === user.user
          && transactionParticipants.length > 1) {
          const transactionAndEventParticipants = transactionParticipants
            .filter((participant) => this.eventContacts
              // eslint-disable-next-line eqeqeq
              .findIndex((contact) => participant.uid === contact.uid) !== -1);
          if (transactionAndEventParticipants.length === this.eventContacts.length) {
            depositStatus += this.$t('statusMessages.incomeForAll');
          } else {
            depositStatus += `${this.$t('statusMessages.incomeFor')}: `;
            transactionParticipants.forEach((participant, index) => {
              if (index !== 0) {
                depositStatus += `, ${this.addVueLinkToUser(this.getContact(participant.uid))}`;
              } else {
                depositStatus += this.$t('CP.meGenitive');
              }
            });
          }
          payeeStatus += `${this.$t(`statusMessages.received_${payeeUser.gender || 'M'}`)}: ${this.$t('CP.me')}`;
        }
        return {
          depositStatus,
          payeeStatus,
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in deposit status: ', e.message);
        return {
          depositStatus: '',
          payeeStatus: '',
        };
      }
    },
    getContactName(id) {
      try {
        const inEventContacts = this.eventContacts.find((contact) => contact.uid === id);
        const inFriends = this.$store.state.user.userContacts.find((contact) => contact.uid === id);
        if (inEventContacts && !inEventContacts.full_name) {
          inEventContacts.full_name = inEventContacts.phone;
        }
        if (inFriends && !inFriends.full_name) {
          inFriends.full_name = inFriends.phone;
        }
        return inEventContacts.full_name || inFriends.full_name;
      } catch (e) {
        return '';
      }
    },
    getContact(id) {
      try {
        const inEventContacts = this.eventContacts.find((contact) => contact.uid === id);
        const inFriends = this.$store.state.user.userContacts.find((contact) => contact.uid === id);
        if (inEventContacts && !inEventContacts.full_name) {
          inEventContacts.full_name = inEventContacts.phone;
        }
        if (inFriends && !inFriends.full_name) {
          inFriends.full_name = inFriends.phone;
        }
        return inEventContacts || inFriends;
      } catch (e) {
        return '';
      }
    },
  },

  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    enableTransition: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'left',
      validate: (position) => ['rigth', 'left'].includes(position),
    },
    transaction: {
      type: Object,
      required: true,
    },
    eventContacts: {
      type: Array,
      default: () => [],
    },
    eventTransactions: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      required: true,
    },
    userExpenses: {
      type: Number,
      default: null,
    },
    showDateTime: {
      type: Boolean,
      default: false,
    },
    lastSeenTransactionId: {
      type: [Number, String],
      default: null,
    },
    isLastTransaction: {
      type: Boolean,
    },
    scrollObserver: {
      type: IntersectionObserver,
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-container {
  overflow: hidden;
}
.transaction {
  word-break: break-word;
  width: 340px;
  min-height: 90px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 15px;
  @media screen and (max-width: $breakpoint-sm) {
    max-width: 75%;
    .transaction__move-transaction {
      margin-left: 0;
    }
  }
}

.transaction__body {
  text-align: left;
  padding: 10px;
  box-sizing: content-box;
  position: relative;
  border-radius: 10px;
  background-color: #F3F6FD;
  height: 80%;
  flex: 1 0 60%;
}

.transaction__message {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.transaction__delete-button {
  cursor: pointer;
}

.transaction__image {
  align-self: flex-end;
}

.right .transaction__body {
  margin-right: 16px;
  border-bottom-right-radius: 0;
}

.left .transaction__body {
  margin-left: 16px;
  border-bottom-left-radius: 0;
}

.message__tail_right {
  content: "";
  position: absolute;
  height: 22px;
  width: 16px;
  bottom: 0;
  right: -16px;
  background: #F3F6FD;
}

.message__tail_right::after {
  content: "";
  width: 16px;
  height: 22px;
  position: absolute;
  background: #FFFFFF;
  border-radius: 0 0 0 100%;
  border: none;
}

.message__tail_left {
  content: "";
  position: absolute;
  height: 22px;
  width: 16px;
  bottom: 0;
  left: -16px;
  background: #F3F6FD;
}

.message__tail_left::after {
  content: "";
  width: 16px;
  height: 22px;
  position: absolute;
  background: #FFFFFF;
  border-radius: 0 0 100% 0;
  border: none;
}

.left {
  margin-right: auto;
}

.right {
  margin-left: auto;
}

.transaction__message {
  font-size: 18px;
  font-weight: bold;
}

.transaction__money {
  font-size: 16px;
  color: #2979FF;
}

.transaction__money_currency {
  font-size: 13px;
}

.transaction__actions {
  opacity: 0;
}

.transaction__body:hover .transaction__actions {
  opacity: 1;
}

.transaction[data-is-mobile='true'] .transaction__actions {
  opacity: 1;
}

.transaction__copy-transaction, .transaction__move-transaction {
  cursor: pointer;
  color: var(--btn-primary);

  &:hover {
    text-decoration: underline;
    color: var(--btn-primary);
  }
}

.transaction__move-transaction {
  margin-left: 5px;
}

.transaction__status {
  font-size: 14px;
  color: var(--text-main-color);
  opacity: 0.6;
}

.transaction__date {
  opacity: 0.6;
  flex: 1 0 100%;
  text-align: right;
  margin-top: 5px;
}

.left .transaction__date {
  text-align: left;
}

.transaction_titleNew {
  align-items: center;
  color: var(--btn-primary);
  display: flex;
  height: 25px;
  justify-content: center;
  margin-bottom: 5px;
  margin-top: 30px;
  position: relative;
  transition: .25s ease;

  &::before {
    background-color: var(--gray-lighten);
    content: '';
    height: 1px;
    position: absolute;
    width: 100%;
  }
  .newTransitionsNotificationHidden & {
    height: 0;
    margin: 0;
    opacity: 0;
    visibility: hidden;
  }
}
.transaction_titleNew-text {
  background-color: #fff;
  padding: 0 15px;
  position: relative;
}
.transaction__seenBy {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 60px;
  width: 100%;

  .transaction.right & {
    justify-content: flex-end;
    padding-left: 0;
    padding-right: 60px;
  }

  li {
    height: 24px;
    margin-right: 3px;
    margin-top: 5px;
    width: 24px;
  }
  .profile-avatar {
    --avatar-height: 24px!important;
    --avatar-width: 24px!important;
  }
}

.transactionDetails {
  color: var(--text-main-color);
  font-family: 'SF UI Display', Avenir, Helvetica, Arial, sans-serif;
  padding: 15px;
}
.transactionDetails_header {
  display: flex;
  margin-bottom: 20px;
}
.transactionDetails_header_info {
  flex: 1;
}
.transactionDetails_header_date {
  font-size: 11px;
  line-height: 1.45em;
  margin-bottom: 10px;
  opacity: 0.4;
  text-align: right;
}
.transactionDetails_picture {
  border-radius: 50%;
  flex-shrink: 0;
  height: 85px;
  margin-right: 20px;
  object-fit: cover;
  width: 85px;
}
.transactionDetails_text {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.22em;
  margin-bottom: 0;
  min-width: 0;
}
.transactionDetails_label {
  font-size: 12px;
  font-weight: normal;
  line-height: 1.83em;
  opacity: 0.4;
}

.transactionDetails_payer {
  margin-top: 15px;

  a {
    color: inherit;
    text-decoration: none;
  }
}

.transactionDetails_participants {
  list-style: none;
  margin: 15px 0 0;
  padding-left: 0;
}
.transactionDetails_participants_item {
  align-items: center;
  display: flex;
  padding: 10px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #E5E5E5;
  }
  .profile-avatar {
    margin-right: 15px;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
}
.transactionDetails_participants_item_amount {
  font-size: 14px;
  margin-left: auto;
  opacity: 0.4;
  padding-left: 10px;
}

.transactionDetails_total {
  font-size: 16px;
  line-height: 1.375em;
  margin-bottom: 20px;
  text-align: right;

  strong {
    color: #303F9F;
    font-weight: 700;
  }
  span {
    font-size: 13px;
    font-weight: 300;
  }
}
.transactionDetails_balanceBefore,
.transactionDetails_balanceAfter {
  font-size: 12px;
  line-height: 1.33em;
  margin-top: 5px;
  text-align: right;
}
.transactionDetails_balanceTitle {
  opacity: 0.6;
}

.transactionDetails_seenBy {
  margin-top: 30px;
  padding-top: 30px;
  position: relative;

  &::before {
    left: calc(-1rem - 15px);
    right: calc(-1rem - 15px);
    background-color: #F3F7FD;
    content: '';
    position: absolute;
    height: 7px;
    top: 0;
  }
  ul {
    list-style: none;
    padding-left: 0;
    margin-top: 5px;
    margin-bottom: 0;
  }
  li {
    align-items: center;
    display: flex;
    padding: 8px 0;
  }
  .profile-avatar {
    margin-right: 8px;
  }
  .transactionDetails_seenBy_name {
    font-size: 13px;
    line-height: 1.69em;

    a {
      color: inherit;
      text-decoration: none;
    }
  }
  .transactionDetails_seenBy_date {
    font-size: 11px;
    line-height: 1.45em;
    margin-left: auto;
    opacity: 0.6;
  }
}
.form-button {
  display: block;
}

@media (min-width: $breakpoint-sm) {
  .form-button {
    display: none;
  }
}
</style>
